// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/tableColumns/codeColumn.js
import translateX from 'utils/translateX';

function codeColumn(buildColumnProps, options = {}) {
  const {
    key = 'code',
    title = 'code',
    dataIndex = 'name',
    width = 160,
    columnProps = { search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: value => {
      if (!value) return <span className="text-muted">—</span>;
      return <span className="text-uppercase font-weight-semibold">{value}</span>;
    },
  };
}

export default codeColumn;
